
import './styles/Header.css';
import Mission from './components/Mission';
import Vision from './components/Vision';
import OurCoreValues from './components/OurCoreValues';
import Header from './components/Header';
import Footer from './components/Footer';

const MissionStatement = () => {
    return (
        <div>
            {/* <HeaderCompanyValues /> */}
            <Header />
            <Mission />
            <Vision />
            <OurCoreValues />
            <Footer />
        </div>
    );
};


export default MissionStatement;
